module.exports = __webpack_public_path__ + "static/media/boat-img-46.a7a87595.jpg";